// Moeda (R$) do campo padrão "Valor" da plataforma.
// formatBRL: número (ou string BR) -> "R$ 55.500"; parseBRL: digitação BR -> número.

export const parseBRL = (raw) => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'number') return raw;
  let s = String(raw).replace(/R\$\s?/g, '').trim();
  if (!s) return null;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  const num = Number(s);
  return Number.isNaN(num) ? null : num;
};

export const formatBRL = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const num = typeof v === 'number' ? v : parseBRL(v);
  if (num === null || Number.isNaN(num)) return String(v);
  return num.toLocaleString('pt-BR', {
    style: 'currency', currency: 'BRL',
    minimumFractionDigits: 0, maximumFractionDigits: 2,
  });
};

// Forma compacta para cabeçalhos ("R$ 1,2 mi" / "R$ 340 mil").
export const formatBRLCompact = (v) => {
  const num = typeof v === 'number' ? v : parseBRL(v);
  if (num === null || Number.isNaN(num)) return '';
  if (Math.abs(num) >= 1_000_000) {
    return `R$ ${(num / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`;
  }
  if (Math.abs(num) >= 10_000) {
    return `R$ ${(num / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })} mil`;
  }
  return formatBRL(num);
};
